import { connect } from 'react-redux';
import DeleteStore from 'components/DanhSachKho/DeleteStore';
import { deleteStore } from 'actions/DeleteStore';

const mapStateToProps = (state) => ({
  deletestore: state.deletestore,
});

const mapDispatchToProps = (dispatch) => ({
  deleteStore: (dataPost) => dispatch(deleteStore(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteStore);
